"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.natToStringifiedNatUnmapper = exports.tryParseStringifiedNat = exports.natToStringifiedNatMapper = void 0;

function natToStringifiedNatMapper(options) {
  var _options = _slicedToArray(options, 2),
      style = _options[0],
      v = _options[1];

  switch (style) {
    case 'oct':
      return "0".concat(Number(v).toString(8));

    case 'hex':
      return "0x".concat(Number(v).toString(16));

    case 'dec':
    default:
      return "".concat(v);
  }
}

exports.natToStringifiedNatMapper = natToStringifiedNatMapper;

function tryParseStringifiedNat(stringValue, radix) {
  var parsedNat = Number.parseInt(stringValue, radix);

  if (parsedNat.toString(radix) !== stringValue) {
    throw new Error('Invalid value');
  }

  return parsedNat;
}

exports.tryParseStringifiedNat = tryParseStringifiedNat;

function natToStringifiedNatUnmapper(value) {
  if (typeof value !== 'string') {
    throw new Error('Invalid type');
  }

  if (value.length >= 2 && value[0] === '0') {
    if (value[1] === 'x') {
      return ['hex', tryParseStringifiedNat(value.substr(2), 16)];
    }

    return ['oct', tryParseStringifiedNat(value.substr(1), 8)];
  }

  return ['dec', tryParseStringifiedNat(value, 10)];
}

exports.natToStringifiedNatUnmapper = natToStringifiedNatUnmapper;